<template>
    <div>
        <v-header :seller="seller" :is-seft="0" ></v-header>
        <v-goods :seller="seller" :is-seft="0"  :is-seft-pay="1"></v-goods>
    </div>
</template>

<script>
    import header from '../components/Header';
    import goods from '../components/BuffetGoods';

    export default {
        inject: ['reload'],
        data() {
            return {
                seller: {}
            }
        },
        created() {
            this.seller = JSON.parse(window.localStorage.getItem('seller') || '{}');
        },
        methods: {
        },
        components: {
            'v-header': header,
            'v-goods': goods
        }
    }
</script>

<style lang="stylus" rel="stylesheet/stylus">

</style>



// WEBPACK FOOTER //
// src/components/BuffetPay.vue